const languageSuffixMap = {
  "fa": "",
  "en": "En",
  "ar": "Ar",
  "tr": "Tr"
}

export default languageSuffixMap